import React from "react";
import FadeInSection from "../../components/FadeInSection";
import ImgPlayer from "../../../images/pngs/software-player.png";
import ImgYourClub from "../../../images/svgs/your-club.svg";
import ImgClubBadge from "../../../images/svgs/club-badge.svg";
import ImgTeamSelection from "../../../images/svgs/team.svg";

const SoftwareSection = () => {
    return (
        <FadeInSection>
            <section className="row gap-2 football-pitch" id="software">
                <div className="container">
                    <h2>Software</h2>
                    <div className="col-12-xs col-4-md">
                        <div className="card">
                            <img src={ImgPlayer} alt="software" className="player-img"/>
                        </div>
                    </div>
                    <div className="col-12-xs col-4-md">
                        <div className="card mb-2">
                            <img src={ImgClubBadge} alt="software" className="club-badge-img"/>
                            <img src={ImgYourClub} alt="software" className="club-img"/>
                            <h3>Customise Your Portal</h3>
                            <ul>
                                <li>
                                    <span className="material-symbols-outlined">task_alt</span>
                                    Brand your portal with your club colours.
                                </li>
                                <li>
                                    <span className="material-symbols-outlined">task_alt</span>
                                    Add your club logo
                                </li>
                                <li>
                                    <span className="material-symbols-outlined">task_alt</span>
                                    Setup Club Shop
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12-xs col-4-md">
                        <div className="card team-management">
                            <h3>Full Team Management</h3>
                            <img src={ImgTeamSelection} alt="software" className="club-img"/>
                            <ul className="mt-1">
                                <li><span className="material-symbols-outlined">task_alt</span>
                                    Manage your Team Selections & Subs
                                </li>
                                <li>
                                    <span className="material-symbols-outlined">task_alt</span>
                                    Update Medical Info
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </FadeInSection>
    );
};

export default SoftwareSection;
